<avi-state-page>
    <avi-state-page_main-content>
        <avi-page-header headerText="{{ globalL10nKeys.wafPolicyLabel | vtranslate }}"></avi-page-header>
        <avi-collection-data-grid [config]="wafPolicyGridConfig"></avi-collection-data-grid>
    </avi-state-page_main-content>
</avi-state-page>
